module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Black.0961c58.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Black.woff
// module id = 9UHu
// module chunks = 0